import React from "react";
import Layout from "../../components/Layout/layout";
import ImportantDates from "../../components/ImportantDates/ImportantDates";
const FeeDetails = () => {
  return (
    <Layout>
      <main className="bg-gray-100 pt-[30vw] mt-[5vw]">
        <div className="flex justify-center">
          <div className="flex absolute md:mt-[-45vw] mt-[-45vw] md:flex-row flex-col items-center w-full justify-center gap-12">
            <div
              className="text-[55px] text-white"
              style={{
                fontFamily: "Bebas Neue",
                textShadow: "2px 1px 0px #000",
              }}
            >
              REGISTRATION
            </div>
          </div>
          <div className="w-full md:w-3/4 md:px-20 px-10 py-32 border-2 mb-20 bg-white md:mt-[-25vw] mt-[-15vw]">
            <div className="font-bold text-2xl text-sky-800 mb-10">
              LATE REGISTRATION FEE *
            </div>
            <div className="font-medium text-xl mb-10">
              # In order to better plan the conference activities for the
              participants, it is decided that the current registration fee will
              be valid till 20 November 2024. Beyond this, the following
              registration fee (called as Late Registration fee) will be
              applicable;
            </div>
            <div className="font-bold text-2xl text-orange-400 mb-10">
              UNTILL NOVEMBER 20, 2024
            </div>
            <div className="overflow-scroll">
              <table className="text-2xl">
                <tr>
                  <td className=" border-orange-400 border-t-2 py-2 w-28"></td>
                  <td className="border-b-2 border-orange-400 border-t-2 py-2">
                    <div className="px-2 py-2 border-r-2 border-l-2 border-orange-400">
                      ISET Members
                    </div>
                  </td>
                  <td className="border-b-2 border-orange-400 border-t-2 px-8 py-4">
                    INR 10000
                  </td>
                </tr>
                <tr>
                  <td className=" border-orange-400"></td>
                  <td className="border-b-2 border-orange-400 py-2">
                    <div className="px-2 py-2 border-r-2 border-l-2 border-orange-400">
                      Non-ISET Members<sup>#</sup>
                    </div>
                  </td>
                  <td className="border-b-2 border-orange-400 px-8 py-4 md:pr-48">
                    INR 12000
                  </td>
                </tr>
                <tr>
                  <td className=" border-orange-400 "> For SAARC Countries</td>
                  <td className="border-b-2 border-orange-400 py-2">
                    <div className="px-2 py-2 border-r-2 border-l-2 border-orange-400">
                      Bonafide Students
                    </div>
                  </td>
                  <td className="border-b-2 border-orange-400 px-8 py-4">
                    INR 6000
                  </td>
                </tr>
                <tr>
                  <td className=" border-orange-400 py-2 border-b-2"></td>
                  <td className="border-b-2 border-orange-400 py-2">
                    <div className="px-2 py-2 border-r-2 border-l-2 border-orange-400">
                      Accompanying Persons
                    </div>
                  </td>
                  <td className="border-b-2 border-orange-400 px-8 py-4">
                    INR 6000
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td className="border-b-2 border-orange-400 py-2">
                    <div className="px-2 py-2 border-r-2 border-l-2 border-orange-400">
                      Foreign Delegates
                    </div>
                  </td>
                  <td className="border-b-2 border-orange-400 px-8 py-4">
                    US $600
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td className="border-b-2 border-orange-400 py-2">
                    <div className="px-2 py-2 border-r-2 border-l-2 border-orange-400">
                      Accompanying Persons
                    </div>
                  </td>
                  <td className="border-b-2 border-orange-400 px-8 py-4">
                    US $300
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td className="border-b-2 border-orange-400 py-2">
                    <div className="px-2 py-2 border-r-2 border-l-2 border-orange-400">
                      Students from abroad
                    </div>
                  </td>
                  <td className="border-b-2 border-orange-400 px-8 py-4">
                    US $300
                  </td>
                </tr>
              </table>
            </div>

            <div className="font-bold text-2xl text-orange-400 mb-10 mt-28">
              After 20<sup>th</sup> NOVEMBER, 2024
            </div>
            <div className="overflow-scroll">
              <table className="text-2xl">
                <tr>
                  <td className=" border-orange-400 border-t-2 py-2 w-28"></td>
                  <td className="border-b-2 border-orange-400 border-t-2 py-2">
                    <div className="px-2 py-2 border-r-2 border-l-2 border-orange-400">
                      ISET Members
                    </div>
                  </td>
                  <td className="border-b-2 border-orange-400 border-t-2 px-8 py-4">
                    INR 12000
                  </td>
                </tr>
                <tr>
                  <td className=" border-orange-400">For SAARC Countries</td>
                  <td className="border-b-2 border-orange-400 py-2">
                    <div className="px-2 py-2 border-r-2 border-l-2 border-orange-400">
                      Non-ISET Members<sup>#</sup>
                    </div>
                  </td>
                  <td className="border-b-2 border-orange-400 px-8 py-4 md:pr-48">
                    INR 14000
                  </td>
                </tr>
                <tr>
                  <td className=" border-orange-400 border-b-2"></td>
                  <td className="border-b-2 border-orange-400 py-2">
                    <div className="px-2 py-2 border-r-2 border-l-2 border-orange-400">
                      Bonafide Students
                    </div>
                  </td>
                  <td className="border-b-2 border-orange-400 px-8 py-4">
                    INR 7000
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td className="border-b-2 border-orange-400 py-2">
                    <div className="px-2 py-2 border-r-2 border-l-2 border-orange-400">
                      Accompanying Persons
                    </div>
                  </td>
                  <td className="border-b-2 border-orange-400 px-8 py-4">
                    INR 7000
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td className="border-b-2 border-orange-400 py-2">
                    <div className="px-2 py-2 border-r-2 border-l-2 border-orange-400">
                      Foreign Delegates
                    </div>
                  </td>
                  <td className="border-b-2 border-orange-400 px-8 py-4">
                    US $650
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td className="border-b-2 border-orange-400 py-2">
                    <div className="px-2 py-2 border-r-2 border-l-2 border-orange-400">
                      Students from abroad
                    </div>
                  </td>
                  <td className="border-b-2 border-orange-400 px-8 py-4">
                    US $350
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td className="border-b-2 border-orange-400 py-2">
                    <div className="px-2 py-2 border-r-2 border-l-2 border-orange-400">
                      Accompanying Persons
                    </div>
                  </td>
                  <td className="border-b-2 border-orange-400 px-8 py-4">
                    US $350
                  </td>
                </tr>
              </table>
            </div>
            <div className="font-medium text-xl mb-5 mt-10">
              *prices are excluding GST
            </div>
            <div className="font-medium text-xl mb-10">
              # For simultaneous registration for the conf. and applying for
              ISET membership, INR 1000 will be waived in membership fee.
            </div>
            <div className="font-medium text-xl mb-10">
              <span className="text-red-600">
                # Registration cancellation policy
              </span>
              : Dear Participants, this is to inform that no cancellation of
              completed registration will be entertained after 5pm on October
              31, 2024 (as on 17/10/2024).
            </div>
          </div>
        </div>
        <div>{/* <ImportantDates /> */}</div>
      </main>
    </Layout>
  );
};

export default FeeDetails;
